export default function Progress({progress, complete, label}) {
    const percent = complete? 100: progress.toFixed(2);
    return (
        <div className="progress">
            <div className={"progress-bar progress-bar-striped" + (complete? "": "progress-bar-animated")} role="progressbar" style={{width: percent + "%"}}>{percent} % {label && "(" + label + ")"}</div>
        </div>
    )
}